<template>
  <v-app id="forgot-password-form">
    <v-main>
      <v-container style="height: 100%; display: grid" :fluid="true">
        <v-row align="center" justify="center">
          <v-col xs="12" sm="8" md="6">
            <v-card class="elevation-4">
              <!--              <v-app-bar flat color="transparent">-->
              <v-row>
                <v-col xs12 class="text-center mt-6">
                  <v-avatar size="48" color="grey">
                    <v-icon size="20" dark>fa-solid fa-lock</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <!--              </v-app-bar>-->
              <v-card-text>
                <!--                <v-form v-bind="valid">-->
                <v-row>
                  <v-col class="px-6">
                    <v-text-field
                      v-model="email"
                      label="Email"
                      type="text"
                      prepend-icon="fa-solid fa-user"
                      color="primary"
                      variant="underlined"
                      validate-on="blur lazy"
                      :rules="emailRules"
                      :disabled="loading"
                      required
                    />
                  </v-col>
                </v-row>
                <!--                <v-text-field-->
                <!--                  :disabled="loading"-->
                <!--                  :rules="emailRules"-->
                <!--                  prepend-icon="person"-->
                <!--                  name="email"-->
                <!--                  label="Email"-->
                <!--                  type="text"-->
                <!--                  v-bind="email"-->
                <!--                  required-->
                <!--                ></v-text-field>-->
                <!--                </v-form>-->
                <!--              </v-card-text>-->
                <!--              <v-card-text class="text-center">-->
                <v-row class="mt-0 px-4">
                  <v-col class="text-center">
                    <span class="font-weight-light">
                      Not registered? Got your invite code?
                      <router-link :to="'/register'">Register Now!</router-link>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pb-8 text-center">
                <v-row class="px-4">
                  <v-col cols="12" class="px-4">
                    <v-btn
                      color="primary"
                      class="mb-3 text-none"
                      style="color: white !important"
                      variant="flat"
                      size="large"
                      :loading="loading"
                      :disabled="loading || !valid"
                      :block="true"
                      @click="doResetPassword"
                    >
                      Reset Password
                      <template v-slot:loader>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </template>
                    </v-btn>
                  </v-col>
                  <!--                </v-row>-->
                  <!--                <v-row>-->
                  <!--                  <v-col>-->
                  <v-col cols="12" class="py-0">
                    <span class="font-weight-light pb-1">
                      <!--                      <router-link-->
                      <!--                        :to="'/login'"-->
                      <!--                        @click="logEvent('login_link')"-->
                      <!--                        >Login</router-link-->
                      <!--                      >-->
                      <a href="/login" @click.prevent="loginNav">Login</a>
                    </span>
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-snackbar
                v-bind="alert"
                color="error"
                :timeout="5000"
                multi-line
                top
              >
                Whoops, Something went wrong. Please try again.
              </v-snackbar>
              <v-snackbar
                v-bind="success"
                color="success"
                :timeout="2000"
                multi-line
                top
              >
                An email has been sent to you.
              </v-snackbar>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import api from "@/services/api.js";
const testEmailExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  name: "forgot-password-form",
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      alert: false,
      success: false,
      emailRules: [
        (v) => !!v || "Email address is required",
        (v) => testEmailExp.test(v) || "Invalid e-mail.",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
      keydownEventListener: null,
    };
  },
  props: {
    source: String,
  },
  methods: {
    doResetPassword() {
      this.loading = true;
      let email = this.email.trim().toLowerCase();

      if (email) {
        api
          .forogtPassword(email)
          .then(() => {
            this.loading = false;
            this.success = true;

            this.$gtag.event("forgot_password_success", {});
          })
          .catch(() => {
            this.loading = false;
            this.alert = true;

            this.$gtag.event("forgot_password_error", {});
          });
      }
    },
    loginNav() {
      this.$gtag.event("login_link", {});
      this.$router.push("/login");
    },
  },
  watch: {
    success(n, o) {
      console.log("new: " + n + ", old:" + o);
      if (!n && o) {
        console.log("redirect...");
        this.$router.push("login");
      }
    },
  },
  created() {},
  mounted() {
    this.keydownEventListener = (e) => {
      if (e.code === "Enter") {
        this.doLogin();
      }
    };
    document.addEventListener("keydown", this.keydownEventListener);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.keydownEventListener);
  },
  computed: {},
};
</script>

<!-- styling for the component -->
<style scoped></style>
